export const trackAffiliateClick = (location) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "claim_bonus_click", {
      event_category: "affiliate_cta",
      event_label: location,
      page_path: window.location.pathname,
    });
  }
};
